import { Routes } from '@angular/router';

// Guards
import { firebaseGuard } from './guards/firebase.guard';
import { canActivate, redirectLoggedInTo, redirectUnauthorizedTo } from "@angular/fire/auth-guard";

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['auth/login']);
const redirectLoggedInToHome = () => redirectLoggedInTo(['home']);

//Modules
import { AuthModule } from './modules/auth/auth.module';
import { LayoutModule } from './modules/layout/layout.module';

export const routes: Routes = [
  {
    path: 'auth',
    ...canActivate(redirectLoggedInToHome),
    loadChildren: () => AuthModule,
  },
  {
    path: '',
    canActivate: [firebaseGuard],
    loadChildren: () => LayoutModule,
  },
  { path: '**', redirectTo: 'error/404' },
];
